import { useState } from "react";
import { signalWord, signalRank } from "./srUtil";

// Only stocks we have a read for are searchable.
export const SrSearch = ({ symbols, onGo }) => {
  const [q, setQ] = useState(""), [open, setOpen] = useState(false), [miss, setMiss] = useState(false);
  const Q = q.trim().toUpperCase();
  const hits = Q ? symbols.filter((s) => s.symbol.startsWith(Q)).slice(0, 8) : [];
  const go = (s) => { setQ(""); setOpen(false); setMiss(false); onGo(s); };
  const submit = (e) => {
    e.preventDefault();
    const exact = symbols.find((s) => s.symbol === Q);
    if (exact || hits[0]) go((exact || hits[0]).symbol);
    else setMiss(!!Q);
  };
  return (
    <form className="search srsearch" onSubmit={submit} data-testid="sr-search-form">
      <input value={q} placeholder="Ticker" aria-label="Search ticker" autoComplete="off" data-testid="sr-search-input"
        onChange={(e) => { setQ(e.target.value); setOpen(true); setMiss(false); }}
        onFocus={() => setOpen(true)} onBlur={() => setTimeout(() => setOpen(false), 150)} />
      <button type="submit" data-testid="sr-search-submit">Read</button>
      {open && hits.length > 0 && (
        <ul className="srsuggest" role="listbox" data-testid="sr-search-suggestions">
          {hits.map((h) => (
            <li key={h.symbol}><button type="button" onMouseDown={() => go(h.symbol)} data-testid={`sr-suggest-${h.symbol}`}>
              <b>{h.symbol}</b><small>{signalWord(h.band)} · {signalRank(h.band)}</small></button></li>
          ))}
        </ul>
      )}
      {miss && <small className="srmiss red" data-testid="sr-search-miss">No match</small>}
    </form>
  );
};
